import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const CompaniesPage = lazy(() => import('./CompaniesPage'));

const CompaniesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Sales,
  routes: [
    {
      path: 'companies',
      element: <CompaniesPage />,
    },
  ],
};

export default CompaniesConfig;
